import { SESSION_TOKEN_KEY } from "../constants";

function toHeaderRecord(headers?: HeadersInit): Record<string, string> {
  if (!headers) {
    return {};
  }

  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries());
  }

  if (Array.isArray(headers)) {
    return Object.fromEntries(headers);
  }

  return headers;
}

function normalizeHeaders(custom?: HeadersInit): Headers {
  return new Headers(custom);
}

export function readSessionToken() {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem(SESSION_TOKEN_KEY);
}

export function getSessionToken() {
  return readSessionToken();
}

export function authHeaders(custom?: HeadersInit): Record<string, string> {
  const headers = normalizeHeaders(custom);
  const token = readSessionToken();

  if (token) {
    headers.set("x-session-token", token);
  }

  return {
    ...toHeaderRecord(custom),
    ...(token ? { "x-session-token": token } : {}),
    "Content-Type": headers.get("content-type") ?? "application/json",
  };
}

export function buildJsonAuthHeaders(custom?: HeadersInit): Record<string, string> {
  return authHeaders(custom);
}

export function createApiClient() {
  return {
    fetch: (url: string, init: RequestInit = {}) =>
      fetch(url, {
        ...init,
        headers: authHeaders(init.headers),
      }),
  };
}
